import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { Flex } from 'src/components/Flex';
import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';
import StatusChip from 'src/components/UserStatusChip/UserStatusChip';
import { formatDate } from 'src/utils/utils';

export const selfBillingInvoiceGridColDefs = (handleView: ({ id }: { id: number }) => void) => {
    return [
        createColumnDef({
            field: 'sageInvoiceNumber',
            headerName: 'Invoice No.',
        }),
        createColumnDef({
            field: 'partnerName',
            headerName: 'Partner Name',
        }),
        createColumnDef({
            field: 'statementDate',
            headerName: 'Statement Date',
            align: 'center',
            renderCell: ({ row }) => {
                // Access statementDate from the first commission statement
                const statementDate = row.commissionStatements?.[0]?.statementDate;
                return (
                    <Flex alignItems={'center'} height={'100%'}>
                        {statementDate ? formatDate(statementDate) : 'N/A'}
                    </Flex>
                );
            },
        }),
        createColumnDef({
            field: 'dateAdded',
            headerName: 'Date Added',
            align: 'center',
            renderCell: ({ row }) => {
                return (
                    <Flex alignItems={'center'} height={'100%'}>
                        {row.dateAdded ? formatDate(row.dateAdded) : 'N/A'}
                    </Flex>
                );
            },
        }),
        createColumnDef({
            field: 'status',
            headerName: 'Status',
            align: 'center',
            renderCell: (params: GridRenderCellParams) => {
                const { status } = params.row;
                return (
                    <Flex alignItems={'center'} height={'100%'} justifyContent={'center'}>
                        {status ? <StatusChip status={status} type="salesInvoice" /> : 'N/A'}
                    </Flex>
                );
            },
        }),
        createColumnDef({
            field: 'actions',
            headerName: 'View',
            disableColumnMenu: true,
            flex: 0,
            minWidth: 160 / 3,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <Flex alignItems={'center'} height={'100%'} justifyContent={'center'}>
                        <IconButton
                            onClick={() => {
                                return handleView({ id: params.row.id });
                            }}
                            aria-label="view"
                        >
                            <VisibilityIcon />
                        </IconButton>
                    </Flex>
                );
            },
        }),
    ];
};

export default selfBillingInvoiceGridColDefs;
